import React from "react";
import { nullDatePrefix, getFriendlyDay } from "./Track";

export const ConsignmentInformation = ({ consignment }) => {
    const specialInstructions = consignment?.specialInstructions || "N/A";
    const pickupAddress = `${consignment?.pickupAddress.location.locality}, ${consignment?.pickupAddress.location.state} ${consignment?.pickupAddress.location.postcode}`;
    const deliveryAddress = `${consignment?.deliveryAddress.location.locality}, ${consignment?.deliveryAddress.location.state} ${consignment?.deliveryAddress.location.postcode}`;
    const estimatedDelivery =
        !consignment?.estimatedDelivery || consignment?.estimatedDelivery.startsWith(nullDatePrefix)
            ? ""
            : getFriendlyDay(consignment?.estimatedDelivery);

    return (
        <>
            <h3 className="consignment-info-title font-weight-bold mb-4">Consignment Information</h3>
            <p className="mb-2">
                <strong className="mr-1">Order reference:</strong>
                <span>{consignment.customerReference}</span>
            </p>
            <p className="mb-2">
                <strong className="mr-1">Special instructions:</strong>
                <span>{specialInstructions}</span>
            </p>

            <p className="mb-2">
                <strong className="mr-1">Estimated delivery:</strong>
                <span>{estimatedDelivery}</span>
            </p>
            <p className="mb-2">
                <strong className="mr-1">Sender location:</strong>
                <span>{pickupAddress}</span>
            </p>
            <p className="mb-2">
                <strong className="mr-1">Receiver location:</strong>
                <span>{deliveryAddress}</span>
            </p>
        </>
    );
};
